export default {
    data: () => ({
        active: false,
        isLoading: false,
        btnLoading: false,
        server_errors: {
            userName: '',
            userEmail: '',
            roleId: '',
            userCardid: '',
            branchId: '',
        },

        roleId: [],
        permissions: [],
        branches: [],
        displayCheckbox: false,
        option: false
    }),

    methods: {
        ShowPermission() {
            this.$axios.get('show-permission-roles', {
                params: {
                    roleId: this.listBranchUser.roleId
                }
            }).then(res => {
                this.permissions = res.data;
            });
        },

        ValidateForm() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.EditItem();
                }
            });
        },

        EditItem() {
            this.btnLoading = true;
            this.listBranchUser.option = this.option;

            this.$axios.put('edit-branch-users', this.listBranchUser).then(res => {
                if (res.data.success == true) {
                    setTimeout(() => {
                        this.btnLoading = false;
                        this.$emit('close');
                        this.$emit('success');
                        this.$notification.OpenNotification_EditItem_OnSuccess('top-right', 'dark', 3000);
                    }, 300);
                }
            }).catch(error => {
                this.btnLoading = false;
                if (error.response.status == 422) {
                    var obj = error.response.data.errors;
                    for (let [key, value] of Object.entries(obj)) {
                        this.server_errors[key] = value[0];
                    }
                }
            });
        },

        FetchData() {
            this.isLoading = true;
            this.$axios.get('list/all/branches').then(res => {
                setTimeout(() => {
                    this.isLoading = false;
                    this.branches = res.data.listBranches;
                    this.FilterBranch();
                }, 100);
            }).catch(() => {
            });
        },

        FilterBranch() {
            const branch = this.branches.filter(item => {
                return item.id == this.listBranchUser.branchId;
            })[0] || {};

            if (branch.distribution_center_id !== null) {
                this.displayCheckbox = true;
                this.option = !!this.listBranchUser.userDistributionCenter;
            } else {
                this.displayCheckbox = false;
                this.option = false;
            }
        }
    },

    watch: {
        'listBranchUser.branchId': function () {
            this.FilterBranch();
        },
        'listBranchUser.userName': function () {
            this.server_errors.userName = '';
        },
        'listBranchUser.userEmail': function () {
            this.server_errors.userEmail = '';
        },
        'listBranchUser.roleId': function () {
            this.server_errors.roleId = '';
        },
        'listBranchUser.userCardid': function () {
            this.server_errors.userCardid = '';
        },
    },
}
